import React from 'react';

import Icon from './icons/Icon';
import notificationTypes from '../../data/constants/notificationTypes';

export function getNotificationIconSrc(notification) {
    const type = notification.content?.data?.type;

    switch (type) {
        case notificationTypes.MEETING_INVITE:
        case notificationTypes.MEETING_CONFIRM_OR_REJECT:
            return '/img/eventmeeting.png';
        case notificationTypes.NEW_ANSWER:
            return '/img/event_qa.png';
        case notificationTypes.NEW_CHAT_MESSAGE:
            return '/img/eventchat.png';
        // case notificationTypes.EVENT_MESSAGE:
        //     break;
        default:
            return '/img/event_news.png';
    }
}

const NotificationIcon = props => {
    const {notification} = props;

    return <Icon {...props} src={getNotificationIconSrc(notification)} />;
};

export default NotificationIcon;
